import axios from 'axios'

const API_ENDPOINT = 'form-submissions'
const PAYMENT_TOKEN_ENDPOINT = API_ENDPOINT + '/payment_token'
const PAYMENT_ATTEMPT_ENDPOINT = API_ENDPOINT + '/payment_attempt'

export default {
    save(formData, formType) {
        const form = new FormData()
        form.append('formType', formType)
        for (var key in formData) {
            for (var key2 in formData[key]) {
                form.append(`formData[${key}][${key2}]`, formData[key][key2])
            }
        }
        formData.project_details.images.forEach(function (image, i) {
            form.append(`files[${i}]`, image.raw)
        })
        return axios.post(API_ENDPOINT, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    },

    getPaymentToken(formId) {
        return axios.post(PAYMENT_TOKEN_ENDPOINT, { formId: formId })
    },

    savePaymentAttempt(formId, status, paymentDetails) {
        return axios.post(PAYMENT_ATTEMPT_ENDPOINT, {
            formId: formId,
            paymentDetails: paymentDetails,
            status: status,
        })
    },
}
